export default __webpack_public_path__ + "static/media/made-easy-1.0a6f9903.png";